import { normalizeHexColor } from '@wilson/utils';

const OUTLINE_BRIGHTNESS_THRESHOLD = 0.9;

export function getHexBrightness(
  hexColor: string | null | undefined,
): number | null {
  const normalized = normalizeHexColor(hexColor);
  if (!normalized) return null;

  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}

export function getContrastTextColor(
  hexColor: string | null | undefined,
): 'black' | 'white' | null {
  const brightness = getHexBrightness(hexColor);
  if (brightness === null) return null;
  return brightness >= 0.5 ? 'black' : 'white';
}

export function hexNeedsOutline(hexColor: string | null | undefined): boolean {
  const brightness = getHexBrightness(hexColor);
  return brightness !== null && brightness >= OUTLINE_BRIGHTNESS_THRESHOLD;
}
